import React from 'react';
import css from './Spinner.module.scss';

export const Spinner = React.memo(() => (
    <div className={css.spinnerContainer} data-testid={'spinner'}>
        <div className={css.spinner}>
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
        </div>
    </div>
));
